
export const FedExServiceTypes: readonly string[] = [
    "FEDEX_GROUND",
    "GROUND_HOME_DELIVERY",
    "FEDEX_2_DAY",
    "FEDEX_2_DAY_AM",
    "FEDEX_EXPRESS_SAVER",
    "STANDARD_OVERNIGHT",
    "PRIORITY_OVERNIGHT",
    "FIRST_OVERNIGHT",
    "SMART_POST",
];

export const UspsServiceTypes: readonly string[] = [
    "usps_priority_mail",
    // Vocabulary for void/reprint/track of manually purchased Express labels — not quoted by
    // the default rate sweep; mirrors the C# catalog.
    "usps_priority_mail_express",
    "usps_first_class_mail",
    "usps_ground_advantage",
];

export const UpsServiceTypes: readonly string[] = [
    "ups_next_day_air",
    "ups_next_day_air_saver",
    "ups_2nd_day_air",
    "ups_ground",
];

/** Combined service-type catalog across all carriers (legacy flat-list consumers). */
export const AllServiceTypes: readonly string[] = [
    ...FedExServiceTypes,
    ...UspsServiceTypes,
    ...UpsServiceTypes,
];

/**
 * Carrier-grouped service-type catalog used by the tabbed config UI. Adding a new
 * carrier list here automatically adds a tab to the Configuration page when the list
 * is non-empty — no other code changes required.
 */
export const ServiceTypeGroups: Record<string, readonly string[]> = {
    FedEx: FedExServiceTypes,
    USPS: UspsServiceTypes,
    UPS: UpsServiceTypes,
};

export const FedExAddOns: readonly string[] = [
    "SATURDAY_DELIVERY",
    "DRY_ICE",
    "PRIORITY_ALERT",
    "PRIORITY_ALERT_PLUS",
    "SHIP_ALERT",
    "ADULT_SIGNATURE_REQUIRED",
    "DIRECT_SIGNATURE_REQUIRED",
    "INDIRECT_SIGNATURE_REQUIRED",
    "NO_SIGNATURE_REQUIRED",
    "HOLD_AT_LOCATION",
];

/** USPS signature add-ons (ShipEngine DeliveryConfirmation enum subset). */
export const UspsAddOns: readonly string[] = [
    "usps_signature_required",
    "usps_adult_signature",
];

/** UPS signature add-ons (ShipEngine DeliveryConfirmation enum subset). */
export const UpsAddOns: readonly string[] = [
    "ups_signature_required",
    "ups_adult_signature",
    "ups_direct_signature",
];

/** Ameriship signature add-ons (boolean flags on AmerishipOrderRequest). */
export const AmerishipAddOns: readonly string[] = [
    "ameriship_signature_required",
    "ameriship_adult_signature",
];

export const AllServiceAddOns: readonly string[] = [
    ...FedExAddOns,
    ...UspsAddOns,
    ...UpsAddOns,
    ...AmerishipAddOns,
];

/** Carrier-grouped add-on catalog used by the tabbed config UI. */
export const ServiceAddOnGroups: Record<string, readonly string[]> = {
    FedEx: FedExAddOns,
    USPS: UspsAddOns,
    UPS: UpsAddOns,
    Ameriship: AmerishipAddOns,
};
